// @ts-nocheck

import { ApiMethod } from '@wajeez-web/stores/base';
import { AppWatch, appWatchClient, Server } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';
import { getWeekFromDate } from '@wajeez-web/core/utils';
import {
  ListWithTotalOutputOfDateWithCountOutput,
  ListWithTotalOutputOfGetDailyRefundsOutput,
} from '@wajeez/wajeez.microservices/dist/api.Server.clients';

export interface DateRangeRequest {
  fromDate?: string;
  toDate?: string;
}

export interface DailyAquiredUsersRequest extends DateRangeRequest {
  SubscriptionDuration: AppWatch.SubscriptionDuration | null;
  SubscriptionType?: AppWatch.SubscriptionType;
}

export interface WithPurchesSourceRequest extends DateRangeRequest {
  purchaseSourceType: AppWatch.PurchaseSourceType;
}

export interface ListWithTotalInput extends WithPurchesSourceRequest {
  SubscriptionPeriod?: AppWatch.SubscriptionDuration;
}
export const getBreakdownOfPremuimsByPurchesSource: ApiMethod<
  DateRangeRequest,
  AppWatch.PremiumsByPurchaseSourceBreakdownResponse[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.paymentQueries_breakdownOfPremiumsByPurchaseSource_V1(
        data.fromDate,
        data.toDate
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getCurrentPremiumCount: ApiMethod<void, number, any> = async (
  _,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_currentPremiumCount_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyBreakdownByPurchesSource: ApiMethod<
  DateRangeRequest,
  AppWatch.DailyBreakdownByPurchaseSourceResponse[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.paymentQueries_dailyBreakdownByPurchaseSource_V1(
        data.fromDate,
        data.toDate
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyBreakdownByPurchesFilteredSource: ApiMethod<
  WithPurchesSourceRequest,
  AppWatch.DailyBreakdownByPurchaseSourceResponse[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.paymentQueries_dailyBreakdownByPurchaseSourceFilteredByPurchaseSourceType_V1(
        data.fromDate,
        data.toDate,
        data.purchaseSourceType
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
export const getFirstTimeSubscriptionBreakdownByWeeks: ApiMethod<
  DateRangeRequest,
  AppWatch.FirstTimeSubscriptionBreakDownByWeekResponse[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const date = new Date(data.fromDate || '');
    const response =
      await client.paymentQueries_firstTimeSubscriptionBreakdownByWeeks_V1(
        date.getFullYear(),
        getWeekFromDate(date)
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getFirstTimeSubscriptionCount: ApiMethod<
  DateRangeRequest,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_firstTimeSubscriptionCount_V1(
      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getPromoCodeAliasBreakdownBySource: ApiMethod<
  DateRangeRequest,
  AppWatch.PromoCodeAliasBreakdownBySourceResponse[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.paymentQueries_promoCodeAliasBreakdownBySource_V1(
        data.fromDate,
        data.toDate
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserRetentionForMultiplePoints: ApiMethod<
  DateRangeRequest,
  AppWatch.MonthlyOverallRetentionResponse[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.paymentQueries_userRetentionForMultiplePoints_V1(
        data.fromDate,
        data.toDate
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyAquiredPremiumUsers: ApiMethod<
  DailyAquiredUsersRequest,
  AppWatch.GetDailyAcquiredPremiumUsersOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_dailyAquiredPremiumUsers_V1(
      data.SubscriptionDuration,
      data.SubscriptionType,
      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyLostPremiumUsers: ApiMethod<
  DailyAquiredUsersRequest,
  AppWatch.GetDailyLostPremiumUsersOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_dailyLostPremiumUsers_V1(
      data.fromDate,
      data.toDate,
      data.SubscriptionDuration
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getExpectedToBeLostPremiums: ApiMethod<
  void,
  AppWatch.GetExpectedToBeLostPremiumsOutput,
  any
> = async (_, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_expectedToBeLostPremiums_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyFirstTimeSubscription: ApiMethod<
  ListWithTotalInput,
  ListWithTotalOutputOfDateWithCountOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_dailyFirstTimeSubscription_V1(
      data.SubscriptionPeriod,
      data.purchaseSourceType,
      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyUpgradeSubscription: ApiMethod<
  WithPurchesSourceRequest,
  ListWithTotalOutputOfDateWithCountOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_dailyUpgradedSubscription_V1(
      data.purchaseSourceType,
      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyDowngradeSubscription: ApiMethod<
  WithPurchesSourceRequest,
  ListWithTotalOutputOfDateWithCountOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_dailyDowngradedSubscription_V1(
      data.purchaseSourceType,
      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyRefunds: ApiMethod<
  ListWithTotalInput,
  ListWithTotalOutputOfGetDailyRefundsOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_dailyRefunds_V1(
      data.SubscriptionPeriod,
      data.purchaseSourceType,
      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getdailyChurnedPremiumUsers: ApiMethod<
  ListWithTotalInput,
  ListWithTotalOutputOfDateWithCountOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_dailyChurnedPremiumUsers_V1(
      data.purchaseSourceType,
      data.SubscriptionPeriod,

      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getdailyReactivedPremiumUsers: ApiMethod<
  ListWithTotalInput,
  ListWithTotalOutputOfDateWithCountOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.paymentQueries_dailyReactivatedPremiumUsers_V1(
        data.purchaseSourceType,
        data.SubscriptionPeriod,

        data.fromDate,
        data.toDate
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyFaildToRenewPremiumUsers: ApiMethod<
  ListWithTotalInput,
  ListWithTotalOutputOfDateWithCountOutput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.paymentQueries_dailyFailedToRenewPremiumUsers_V1(
        data.purchaseSourceType,
        data.SubscriptionPeriod,

        data.fromDate,
        data.toDate
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyPromoCodeAlias: ApiMethod<
  ListWithTotalInput,
  Server.GetDailyPromoCodeAliasBreakdownBySourceOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_dailyPromoCodeAlias_V1(
      data.purchaseSourceType,
      data.SubscriptionPeriod,

      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
